import { get } from '../../../../DAL/data-provider';

/**
 * /api/sitesearch/explore-search?query=cla
 */
export const getSearchData = async (query: string) => {
    return get('/api/sitesearch/explore-search', {
        query: query.trim(),
    });
};